module.exports = __webpack_public_path__ + "static/img/pc-background.f67e261.png";